/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/11/11
 * @updateTime 2021/11/11
 * @decription 复议业务相关的工具方法
 */

export default {
    /**
     * 获取申请人名称
     * @param {Object} sqrItemData 申请人信息项数据
     * @returns {String} 申请人名称
     * */
    getSqrMc(sqrItemData) {
        // 如果申请人类型是自然人，则取申请人姓名，否则取企业名称
        return sqrItemData.cSqrlx === '1' ? sqrItemData.cSqrxm : sqrItemData.cQymc;
    },

    /**
     * 获取代理人所属原告名称
     * @param {Array<String>} sqrIds 代理人所属申请人id集合
     * @parma {Array<Object>} sqrDataList 申请人数据列表
     * @returns {String} 原告名称字符串
     * */
    getDlrSsygMc(sqrIds, sqrDataList) {
        // 复议申请人名称
        let _cFySqrTexts = [];
        sqrDataList.every(item => {
            // 对应的索引index
            const _index = sqrIds.indexOf(item.cId);
            if (_index > -1) {
                // 申请人名称
                _cFySqrTexts.push(this.getSqrMc(item));
            }
            return true;
        });
        return _cFySqrTexts.join(',');
    }
};
